import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import { trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import SimpleCrypto from "simple-crypto-js";
import config from "../../../baseConfig/index";
import ErrorModal from "../../Fragments/ErrorModal";
import Select from "react-select";
import { localStorageGetItem, localStorageSetItem } from "../../../storage";

class B2bLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      _token: this.props.csrf_token.data,
      showErrorModal: false,
      formResponse: "",
      buttonDisabled: false,
      selectedOption:
        this.options()[localStorageGetItem("b2bSelectedType") || 0],
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleSelectChange(newState) {
    this.setState({
      selectedOption: newState,
    });

    localStorageSetItem("b2bSelectedType", newState.value);
  }

  componentDidUpdate() {
    if (this.props.languageChanged) {
      this.setState({
        selectedOption:
          this.options()[localStorageGetItem("b2bSelectedType") || 0],
      });

      this.props.updateParentState({
        languageChanged: false,
      });
    }
  }

  options() {
    return [
      {
        value: 0,
        label: trans(this.props.trans, "b2b.login_form.select_option_text1"),
      },
      {
        value: 1,
        label: trans(this.props.trans, "b2b.login_form.select_option_text2"),
      },
    ];
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  reSendData() {
    this.setState({ buttonDisabled: true });

    ApiManager.getRequest({}, "/csrf-token").then(
      (resolve) => {
        this.props.setTokenAction(resolve.data);
        this.setState({ _token: resolve.data.data });
        this.sendData();
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  sendData() {
    this.setState({ buttonDisabled: true });
    const isCurator = this.state.selectedOption.value === 1;

    ApiManager.postRequest(
      {
        email: this.props.b2bEmail,
        password: this.state.password,
        _token: this.state._token,
      },
      "/b2b" + (isCurator ? "curator" : "") + "/login"
    ).then(
      (resolve) => {
        // @test
        // resolve.data = { "status": "OK", "user_status": "new", "jwt": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9sb2NhbGhvc3QiLCJhdWQiOiJodHRwOlwvXC9sb2NhbGhvc3QiLCJpYXQiOjE1NzYxNTcwMzEsIm5iZiI6MTU3NjE1NzAzMSwiZXhwIjoxNTc3NDUzMDMxLCJpZCI6MTQsImFjY291bnRfaWQiOm51bGx9.-EDGHDVyrLfAbt_ad7owyL20KKEQMQRMYiijCzAJDB4", "jwt_widget": null };

        this.setState({
          buttonDisabled: false,
          formResponse: resolve.data,
        });

        if (
          resolve.data.status === "OK" &&
          resolve.data.user_status === "confirmed"
        ) {
          const simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey);
          this.props.cookies.set(
            "loginTokenB2b",
            simpleCrypto.encrypt(resolve.data.jwt),
            { path: config.urlPrefix }
          );

          if (isCurator) {
            this.props.cookies.set("loginByCurator", 1, {
              path: config.urlPrefix,
            });
          }

          this.props.history.push(config.urlPrefix + "b2b");
        } else if (
          resolve.data.status === "OK" &&
          resolve.data.user_status === "new"
        ) {
          this.props.updateParentState({
            b2bForm: 2,
            b2bJwt: resolve.data.jwt,
            isCurator,
          });
        } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
          this.reSendData();
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  render() {
    let emailErrorClass = "",
      emailErrorBox = "",
      passwordErrorClass = "",
      passwordErrorBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("email")) {
          emailErrorClass = " form-error";
          emailErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.email}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("password")) {
          passwordErrorClass = " form-error";
          passwordErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.password}
            </div>
          );
        }
      }

      if (
        this.state.formResponse.status === "ERROR" ||
        this.state.formResponse.status === "NOT_FOUND"
      ) {
        errorBox = (
          <FormMiddlewareError message={this.state.formResponse.message} />
        );
      }
    }

    return (
      <div className="form">
        <form
          action="#"
          method="post"
          onSubmit={(event) => {
            event.preventDefault();
            this.sendData();
          }}
        >
          <p className="form__top-desc">
            {trans(this.props.trans, "b2b.login_form.description")}
          </p>

          <div className="form__form-box">
            <label className="form__label db fs11" htmlFor="login-type">
              {trans(this.props.trans, "b2b.login_form.select.label")}
            </label>
            <div className="form__field-out form__field-out--select-big">
              <Select
                options={this.options()}
                value={this.state.selectedOption}
                onChange={this.handleSelectChange}
                placeholder={trans(
                  this.props.trans,
                  "b2b.login_form.select_default_label"
                )}
                noOptionsMessage={() =>
                  trans(
                    this.props.trans,
                    "b2b.login_form.select_no_options_message"
                  )
                }
                isSearchable={false}
              />
            </div>
          </div>

          <div className={`form__form-box${emailErrorClass}`}>
            <label className="form__label db fs11" htmlFor="tel-number">
              {trans(this.props.trans, "b2b.login_form.fullname.label")}
            </label>
            <div className="form__field-out pr">
              <input
                className="form__field form__field--right-space fs13"
                type="text"
                placeholder={trans(
                  this.props.trans,
                  "b2b.login_form.fullname.placeholder"
                )}
                onChange={(event) => {
                  this.props.updateParentState({
                    b2bEmail: event.target.value.trim(),
                  });
                }}
                value={this.props.b2bEmail}
              />
              <div className="form__info-box pa">
                <span className="form__info sprite db"> </span>
                <div className="form__info-txt fs11 pa">
                  {trans(
                    this.props.trans,
                    "b2b.login_form.fullname.description"
                  )}
                </div>
              </div>
            </div>
            {emailErrorBox}
          </div>
          <div className={`form__form-box${passwordErrorClass}`}>
            <label className="form__label  db fs11" htmlFor="password">
              {trans(this.props.trans, "b2b.login_form.password.label")}
            </label>
            <div className="form__field-out pr">
              <input
                className="form__field form__field--right-space fs13"
                type="password"
                placeholder={trans(
                  this.props.trans,
                  "b2b.login_form.password.placeholder"
                )}
                onChange={(event) => {
                  this.setState({ password: event.target.value.trim() });
                }}
                value={this.state.password}
              />
              <div className="form__info-box pa">
                <span className="form__info sprite db"> </span>
                <div className="form__info-txt fs11 pa">
                  {trans(
                    this.props.trans,
                    "b2b.login_form.password.description"
                  )}
                </div>
              </div>
            </div>
            {passwordErrorBox}
          </div>

          {errorBox}

          <button
            className={`form__submit-btn btn btn--with-space btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={this.state.buttonDisabled}
          >
            {trans(this.props.trans, "b2b.login_form.button.label")}
          </button>

          <Link
            className="form__link form__link--with-space fs13 db tc"
            to={config.urlPrefix + `forgot-password-b2b`}
          >
            {trans(this.props.trans, "b2b.login_form.forgot_password.label")}
          </Link>

          <p
            className="form__register-desc-txt fs13 tc"
            dangerouslySetInnerHTML={{
              __html: trans(this.props.trans, "b2b.login_form.info.text"),
            }}
          />
        </form>
        {this.errorModal()}
      </div>
    );
  }
}

export default withRouter(withCookies(B2bLogin));
